import { config } from "../../../../enviroment";
import {apolloClientService} from '../../../../services/apollo-client';

export const promotionsService = {
    getPromotions
}

  async function getPromotions(
    startDate,
    customerClass,
    announcementEndDate
  ) {
    const  APIinput =
        `query{getAnnouncementList(input:{IsPublic:"LOGGED_IN",announcementType:"PROMOTIONS",StartDate:"` +
        startDate +
        `",EndDate:"` +
        announcementEndDate +
        `",CustomerClass:"` +
        customerClass +
        `"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate,AnnouncementType,AnnouncementStatus,CustomerClass,IsPublic,IsRead,ContentIconName}}`;
    
  
    return await apolloClientService.ApolloClientgqlsCommunication(APIinput, "", "network-only");
  }